// @ts-nocheck
import {
  MagnifyingGlass,
  Calendar,
  SquaresFour,
  FileText,
  Kanban,
  BookOpen,
  Target,
  Megaphone,
  Lightning,
  Envelope,
  ChatCircle,
  FolderOpen,
  HardDrives,
  GitBranch,
  Ticket,
  ChartLine,
  Headphones,
  Cloud,
  Palette,
  Users,
  CheckCircle,
  ChartBar,
  Link,
  Shield,
  Lock,
  ArrowsClockwise,
  Database,
} from '@phosphor-icons/react';

export const PRODUCT_NAME = 'Torch';

// Search demo queries and results
export const SEARCH_QUERIES = [
  {
    query: 'Q3 board meeting notes',
    results: [
      { title: 'Q3 Board Meeting - Final Deck', source: 'Google Drive', icon: FolderOpen, time: '2 days ago', snippet: 'Revenue grew 34% YoY. Key initiatives for Q4 include...' },
      { title: 'Board meeting action items', source: 'Notion', icon: FileText, time: '2 days ago', snippet: 'Follow up on enterprise pipeline, finalize Q4 budget...' },
      { title: '#board-prep channel discussion', source: 'Slack', icon: ChatCircle, time: '3 days ago', snippet: 'Sarah: Updated the competitive analysis slide...' },
      { title: 'Re: Board deck review', source: 'Gmail', icon: Envelope, time: '4 days ago', snippet: 'Looks good. One note on the ARR projection...' },
    ],
  },
  {
    query: 'deployment pipeline status',
    results: [
      { title: 'CI/CD Pipeline - main branch', source: 'GitHub', icon: GitBranch, time: '12 min ago', snippet: 'All checks passed. Deploy to staging complete.' },
      { title: 'Deploy runbook v2', source: 'Notion', icon: FileText, time: '1 week ago', snippet: 'Step 1: Verify staging. Step 2: Run migration...' },
      { title: '#deployments alert', source: 'Slack', icon: ChatCircle, time: '1 hour ago', snippet: 'Production deploy succeeded for v2.4.1' },
      { title: 'Pipeline optimization PR', source: 'GitHub', icon: GitBranch, time: '3 days ago', snippet: 'Reduced build time from 8min to 3min by caching...' },
    ],
  },
  {
    query: 'API rate limiting design',
    results: [
      { title: 'Rate Limiting RFC', source: 'Google Drive', icon: FolderOpen, time: '1 week ago', snippet: 'Proposed: Token bucket algorithm with 1000 req/min...' },
      { title: 'RATE-231: Implement rate limiter', source: 'Jira', icon: Ticket, time: '5 days ago', snippet: 'Status: In Review. Assigned to: Mike Chen' },
      { title: 'Rate limit middleware PR #482', source: 'GitHub', icon: GitBranch, time: '3 days ago', snippet: 'Added sliding window counter with Redis backend...' },
      { title: 'API throttling discussion', source: 'Slack', icon: ChatCircle, time: '6 days ago', snippet: 'We should start with 429 responses, then add...' },
    ],
  },
];

// Built-in apps
export const APPS = [
  {
    icon: Kanban,
    name: 'Kanban',
    description: 'Drag cards between columns. Replaces Trello and Linear.',
  },
  {
    icon: Calendar,
    name: 'Calendar',
    description: 'Google + Outlook events in one view.',
  },
  {
    icon: FileText,
    name: 'Documents',
    description: 'Markdown docs with real-time collaboration.',
  },
  {
    icon: BookOpen,
    name: 'Wiki',
    description: 'Nested pages your whole team can search.',
  },
  {
    icon: Target,
    name: 'OKRs',
    description: 'Objectives and key results with progress tracking.',
  },
  {
    icon: Lightning,
    name: 'Sprints',
    description: 'Two-week cycles with velocity and burndown.',
  },
  {
    icon: Megaphone,
    name: 'Announcements',
    description: 'Team updates with read receipts.',
  },
  {
    icon: SquaresFour,
    name: 'Notes',
    description: 'Quick capture, linked to anything in your workspace.',
  },
];

// Integration names with category icons
export const INTEGRATIONS = [
  { name: 'Gmail', icon: Envelope, category: 'email' },
  { name: 'Google Drive', icon: FolderOpen, category: 'storage' },
  { name: 'Google Calendar', icon: Calendar, category: 'calendar' },
  { name: 'Slack', icon: ChatCircle, category: 'messaging' },
  { name: 'Notion', icon: FileText, category: 'docs' },
  { name: 'GitHub', icon: GitBranch, category: 'dev' },
  { name: 'Jira', icon: Ticket, category: 'project' },
  { name: 'Linear', icon: ChartLine, category: 'project' },
  { name: 'Confluence', icon: BookOpen, category: 'docs' },
  { name: 'Asana', icon: CheckCircle, category: 'project' },
  { name: 'Trello', icon: Kanban, category: 'project' },
  { name: 'Salesforce', icon: ChartBar, category: 'crm' },
  { name: 'HubSpot', icon: Users, category: 'crm' },
  { name: 'Figma', icon: Palette, category: 'design' },
  { name: 'Dropbox', icon: HardDrives, category: 'storage' },
  { name: 'OneDrive', icon: Cloud, category: 'storage' },
  { name: 'Outlook', icon: Envelope, category: 'email' },
  { name: 'Microsoft Teams', icon: ChatCircle, category: 'messaging' },
  { name: 'Zendesk', icon: Headphones, category: 'support' },
  { name: 'Intercom', icon: ChatCircle, category: 'support' },
];

// How it works steps
export const HOW_IT_WORKS = [
  {
    step: '01',
    title: 'Connect your apps',
    description: 'One-click OAuth for each integration. Gmail, Slack, Notion, GitHub, Jira — connect in seconds, not hours.',
    icon: Link,
  },
  {
    step: '02',
    title: 'Search everything',
    description: 'One search bar, all your tools. Permissions-aware, real-time indexed, instantly find anything across your entire stack.',
    icon: MagnifyingGlass,
  },
  {
    step: '03',
    title: 'Work in one place',
    description: 'Built-in kanban, docs, wiki, and calendar replace standalone tools. Everything works together on one unified data layer.',
    icon: SquaresFour,
  },
];

// Pricing tiers
export const PRICING_TIERS = [
  {
    name: 'Free',
    price: '$0',
    period: 'forever',
    description: 'For individuals getting started',
    features: [
      '3 connected apps',
      'Core search features',
      '1 user',
      'Built-in productivity apps',
      'Community support',
    ],
    cta: 'Get Started',
    highlighted: false,
  },
  {
    name: 'Pro',
    price: '$14',
    period: '/user/mo',
    description: 'For power users who need more',
    features: [
      'Unlimited connected apps',
      'Priority search indexing',
      'Advanced filters & saved searches',
      'All built-in apps',
      'API access',
      'Email support',
    ],
    cta: 'Get Started',
    highlighted: true,
  },
  {
    name: 'Team',
    price: '$22',
    period: '/user/mo',
    description: 'For teams that work together',
    features: [
      'Everything in Pro',
      'Team workspaces',
      'Admin controls & analytics',
      'Shared labels & filters',
      'Priority support',
    ],
    cta: 'Get Started',
    highlighted: false,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    description: 'For organizations with compliance needs',
    features: [
      'Everything in Team',
      'SSO / SAML',
      'Audit logs',
      'API access',
      'SLA & dedicated support',
      'Custom integrations',
    ],
    cta: 'Contact Us',
    highlighted: false,
  },
];

// Comparison / replace your stack
export const REPLACEMENTS = [
  { tool: 'Notion', price: '$10/mo', replacement: 'Wiki + Docs' },
  { tool: 'Linear', price: '$8/mo', replacement: 'Kanban + Sprints' },
  { tool: 'Lattice', price: '$11/mo', replacement: 'OKRs' },
  { tool: 'Workplace', price: '$4/mo', replacement: 'Announcements' },
  { tool: 'Glean', price: '$10+/mo', replacement: 'Unified search' },
];

// Security features
export const SECURITY_FEATURES = [
  { icon: Shield, title: 'Permissions-Aware', desc: 'Users only see what they can access in each connected system' },
  { icon: Lock, title: 'SSO & SAML', desc: 'Enterprise authentication with WorkOS' },
  { icon: ArrowsClockwise, title: 'Real-Time Sync', desc: 'Data stays up-to-date automatically' },
  { icon: Database, title: 'Source of Truth', desc: 'Deep links back to original systems' },
];

// Nav links
export const NAV_LINKS = [
  { label: 'Search', href: '#search' },
  { label: 'Apps', href: '#apps' },
  { label: 'Integrations', href: '/integrations', route: true },
  { label: 'Pricing', href: '/pricing', route: true },
  { label: 'Use Cases', href: '/use-cases', route: true },
];
